export default __webpack_public_path__ + "static/media/logo_text.a5e4f626.png";